<div class="overview-page">
  <div class="page-header">
    <div class="page-header__title">
      <h2 id="execution-board-title">{{ 'Execution board' | translate }}</h2>
      <p>
        {{ 'Workers online' | translate }}:
        <strong>{{ workersOnline() }}</strong>
        /
        {{ workersTotal() }}
      </p>
    </div>
    <div class="page-header__search">
      <app-orchestration-catalog-search [(query)]="searchQuery"></app-orchestration-catalog-search>
    </div>
  </div>

  <div class="storage-boards">
    <app-orchestration-database-slot-board
      heading="Postgres"
      [snapshot]="connections()"
      [errorMessage]="connectionsError()"
      [loading]="connectionsLoading()"
    ></app-orchestration-database-slot-board>
    <app-orchestration-object-storage-board
      heading="Object storage"
      [snapshot]="storageSnapshot()"
      [errorMessage]="storageError()"
      [loading]="storageLoading()"
    ></app-orchestration-object-storage-board>
  </div>

  <section class="execution-board" aria-labelledby="execution-board-title">
    @if (loading() && !statistics()) {
      <app-loading [loading]="true"></app-loading>
    } @else if (errorMessage() && !statistics()) {
      <div class="error-message">{{ errorMessage() | translate }}</div>
    } @else {
      <div class="module-grid">
        @for (module of visibleCards(); track module.id) {
          <a
            class="module-card"
            [attr.data-module]="module.id"
            routerLink="processes">
            <i class="module-card__mark" [ngClass]="module.icon" aria-hidden="true"></i>
            <h3>{{ module.labelKey | translate }}</h3>
            <dl>
              <div>
                <dt>{{ 'In progress' | translate }}</dt>
                <dd>{{ module.inProgress }} / {{ module.jobInProgress }}</dd>
              </div>
              <div>
                <dt>{{ 'Success' | translate }}</dt>
                <dd class="is-success">{{ module.succeeded }}</dd>
              </div>
              <div>
                <dt>{{ 'Failed' | translate }}</dt>
                <dd class="is-failed">{{ module.failed }}</dd>
              </div>
              <div>
                <dt>{{ 'Result' | translate }}</dt>
                <dd>{{ module.resultCount }}</dd>
              </div>
              <div class="jobs-mini">
                <dt>{{ 'Job work' | translate }}</dt>
                <dd>
                  <span class="is-success">{{ module.jobSucceeded }}</span>
                  /
                  <span class="is-failed">{{ module.jobFailed }}</span>
                </dd>
              </div>
            </dl>
          </a>
        }
      </div>
    }
  </section>

  <ng-template #processLink let-row>
    <a [routerLink]="['processes', row.processKey]">{{ row.processKey }}</a>
  </ng-template>

  <section class="reliability-board" aria-labelledby="reliability-title">
    <h3 id="reliability-title">{{ 'Process reliability' | translate }}</h3>
    <p class="reliability-note">{{ 'Last 30 days' | translate }}</p>
    @if (reliabilityLoading() && !reliability()) {
      <app-loading [loading]="true"></app-loading>
    } @else if (reliabilityError() && !reliability()) {
      <div class="error-message">{{ reliabilityError() | translate }}</div>
    } @else {
      <h4>{{ 'Processes that never succeed' | translate }}</h4>
      <app-data-table
        [columns]="reliabilityColumns()"
        [data]="brokenRows()"
        [config]="reliabilityTableConfig"
        [loading]="reliabilityLoading()"
      ></app-data-table>
      <h4>{{ 'Processes that fail intermittently' | translate }}</h4>
      <app-data-table
        [columns]="reliabilityColumns()"
        [data]="intermittentRows()"
        [config]="reliabilityTableConfig"
        [loading]="reliabilityLoading()"
      ></app-data-table>
    }
  </section>
</div>
